import React, { useState, useEffect, useContext, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import './head.scss';
import { Dropdown, Input } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { Context } from '@/models/home';

const { Search } = Input;

function Head() {
  let history = useHistory();
  const HomeContext = useContext(Context);

  const getQueryVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return false;
  };

  const [titleArr, setTitleArr] = useState(
    decodeURI(getQueryVariable('title')).split('/'),
  );
  const titleArrRef = useRef(titleArr);
  titleArrRef.current = titleArr;

  useEffect(() => {
    const unlisten = history.listen(() => {
      setTitleArr(decodeURI(getQueryVariable('title')).split('/'));
    });
    return () => unlisten();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    actStyle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [titleArr]);

  const actStyle = () => {
    initStyle();
    switch (titleArr[0]) {
      case '资讯中心':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[0].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;
      case '学术与规划':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[1].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;
      case '科普园地':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[2].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;
      case '品牌活动':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[3].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;
      case '会员之家':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[4].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;
      case '《江苏通信》':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[5].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;
      case '标准化':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[6].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;
      case '科技服务':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[7].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;
      case '关于学会':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[8].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;

      default:
        break;
    }
  };

  const onSearch = (value) => {
    // console.log(value);
    history.push(`list?title=ssjg&keywords=${value}`);
  };

  const toRouter = (path) => {
    history.push(path);
  };

  const toMenu = (title) => {
    HomeContext.state.menuList &&
      Object.keys(HomeContext.state.menuList).map((i) => {
        HomeContext.state.menuList[i].map((item) => {
          if (item.title === HomeContext.state.menuTitleList[title]) {
            history.push(item.path);
          }
          return null;
        });
        return null;
      });
    HomeContext.state.newsTypeList &&
      HomeContext.state.newsTypeList.map((i) => {
        if (i.name === HomeContext.state.menuTitleList[title]) {
          history.push(
            `/list?title=${HomeContext.state.menuTitleList[title]}&id=${i.id}&isMenu=true`,
          );
        }
        return null;
      });
  };

  const onClick = ({ key }) => {
    toMenu(key);
  };

    const menu1 = [
        { key: '公告栏', label: <><RightOutlined /> 公告栏</> },
        { key: '学会动态', label: <><RightOutlined /> 学会动态</> },
        { key: '分支机构动态', label: <><RightOutlined /> 分支机构动态</> },
        { key: '地市学会动态', label: <><RightOutlined /> 地市学会动态</> },
      ];
    const menu2 = [
        { key: '前瞻技术', label: <><RightOutlined /> 前瞻技术</> },
        { key: '法规与政策', label: <><RightOutlined /> 法规与政策</> },
        { key: '规划与发展', label: <><RightOutlined /> 规划与发展</> },
        { key: '行业要闻', label: <><RightOutlined /> 行业要闻</> },
      ];
    const menu3 = [
        { key: '科普作品', label: <><RightOutlined /> 科普作品</> },
        { key: '科普视频', label: <><RightOutlined /> 科普视频</> },
        { key: '科普场馆', label: <><RightOutlined /> 科普场馆</> },
      ];
    const menu4 = [
        { key: '世界电信和信息社会日纪念大会', label: <><RightOutlined /> 世界电信和信息社会日纪念大会</> },
        { key: '江苏信息通信行业科学技术奖', label: <><RightOutlined /> 江苏信息通信行业科学技术奖</> },
        { key: '青年学术论坛', label: <><RightOutlined /> 青年学术论坛</> },
        { key: '论文征集', label: <><RightOutlined /> 论文征集</> },
      ];
    const menu5 = [
        { key: '会员单位', label: <><RightOutlined /> 会员单位</> },
        { key: '会员动态', label: <><RightOutlined /> 会员动态</> },
        { key: '合作需求', label: <><RightOutlined /> 合作需求</> },
      ];
    const menu6 = [
        { key: '近期目录', label: <><RightOutlined /> 近期目录</> },
        { key: '征稿启事', label: <><RightOutlined /> 征稿启事</> },
        { key: '论文集', label: <><RightOutlined /> 论文集</> },
      ];
    const menu7 = [
        { key: '团体标准', label: <><RightOutlined /> 团体标准</> },
        { key: '地方标准', label: <><RightOutlined /> 地方标准</> },
        { key: '行业标准', label: <><RightOutlined /> 行业标准</> },
        { key: '国家标准', label: <><RightOutlined /> 国家标准</> },
      ];
    const menu8 = [
        { key: '咨询与智库', label: <><RightOutlined /> 咨询与智库</> },
        { key: '科技评价', label: <><RightOutlined /> 科技评价</> },
      ];
    const menu9 = [
        { key: '党的建设', label: <><RightOutlined /> 党的建设</> },
        { key: '学会简介', label: <><RightOutlined /> 学会简介</> },
        { key: '学会章程', label: <><RightOutlined /> 学会章程</> },
        { key: '组织架构', label: <><RightOutlined /> 组织架构</> },
        { key: '理事会名单', label: <><RightOutlined /> 理事会名单</> },
        { key: '监事会名单', label: <><RightOutlined /> 监事会名单</> },
        { key: '分支机构', label: <><RightOutlined /> 分支机构</> },
        { key: '地市学会', label: <><RightOutlined /> 地市学会</> },
        { key: '管理办法', label: <><RightOutlined /> 管理办法</> },
        { key: '加入学会', label: <><RightOutlined /> 加入学会</> },
        { key: '联系我们', label: <><RightOutlined /> 联系我们</> },
      ];

  const initStyle = () => {
    const docArr = [...document.querySelectorAll('.ant-dropdown-trigger')];
    docArr.map((item) => {
      item.style.backgroundImage = 'none';
      return null;
    });
  };

  return (
    <div>
      <div className="headerBox">
        <div className="center logo">
          <div>
            <img src={require('@/assets/home/logo.png').default} alt=""></img>
            <img src={require('@/assets/home/topTitle.png').default} alt=""></img>
          </div>
          <div className="search">
            <Search
              placeholder="请输入关键字"
              allowClear
              onSearch={onSearch}
              style={{ margin: '0 10px' }}
            />
          </div>
        </div>
      </div>
      <div className="menu">
        {/* <ul className="clearfix center">
          <li onClick={toRouter.bind(this, '')}>首页</li>
          <li onClick={toMenu.bind(this, '资讯中心')}>资讯中心</li>
          <li onClick={toMenu.bind(this, '学术与规划')}>学术与规划</li>
          <li onClick={toMenu.bind(this, '科普园地')}>科普园地</li>
          <li onClick={toMenu.bind(this, '品牌活动')}>品牌活动</li>
          <li onClick={toMenu.bind(this, '会员之家')}>会员之家</li>
          <li onClick={toMenu.bind(this, '《江苏通信》')}>《江苏通信》</li>
          <li onClick={toMenu.bind(this, '标准化')}>标准化</li>
          <li onClick={toMenu.bind(this, '科技服务')}>科技服务</li>
          <li onClick={toMenu.bind(this, '关于学会')}>关于学会</li>
        </ul> */}
        <span onClick={toRouter.bind(this, '')}>
          <div>首页</div>
        </span>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'zxzx' ? 'act' : ''}
          onClick={toMenu.bind(this, '资讯中心')}
          menu={{ items: menu1, onClick }}
          onOpenChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[0].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';
            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[0].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>资讯中心</div>
        </Dropdown>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'xsygh' ? 'act' : ''}
          onClick={toMenu.bind(this, '学术与规划')}
          menu={{ items: menu2, onClick }}
          onOpenChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[1].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';

            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[1].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>学术与规划</div>
        </Dropdown>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'kpyd' ? 'act' : ''}
          onClick={toMenu.bind(this, '科普园地')}
          menu={{ items: menu3, onClick }}
          onOpenChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[2].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';

            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[2].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>科普园地</div>
        </Dropdown>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'pphd' ? 'act' : ''}
          onClick={toMenu.bind(this, '品牌活动')}
          menu={{ items: menu4, onClick }}
          onOpenChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[3].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';

            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[3].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>品牌活动</div>
        </Dropdown>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'hyfc' ? 'act' : ''}
          onClick={toMenu.bind(this, '会员之家')}
          menu={{ items: menu5, onClick }}
          onOpenChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[4].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';

            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[4].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>会员之家</div>
        </Dropdown>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'jstx' ? 'act' : ''}
          onClick={toMenu.bind(this, '《江苏通信》')}
          menu={{ items: menu6, onClick }}
          onOpenChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[5].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';

            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[5].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>《江苏通信》</div>
        </Dropdown>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'bzh' ? 'act' : ''}
          onClick={toMenu.bind(this, '标准化')}
          menu={{ items: menu7, onClick }}
          onOpenChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[6].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';

            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[6].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>标准化</div>
        </Dropdown>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'kjfw' ? 'act' : ''}
          onClick={toMenu.bind(this, '科技服务')}
          menu={{ items: menu8, onClick }}
          onOpenChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[7].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';

            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[7].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>科技服务</div>
        </Dropdown>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'gyxh' ? 'act' : ''}
          onClick={toMenu.bind(this, '关于学会')}
          menu={{ items: menu9, onClick }}
          onOpenChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[8].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';

            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[8].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>关于学会</div>
        </Dropdown>
      </div>
      {/* <ul className="lisBox clearfix">
        <div className="liBox">
          <div>
            {HomeContext.state.menuList && menuTitle
              ? HomeContext.state.menuList[menuTitle].map((item, index) => {
                  return (
                    item.title && (
                      <li key={index} onClick={toRouter.bind(this, item.path)}>
                        <RightOutlined /> {item.title}
                      </li>
                    )
                  );
                })
              : null}
          </div>
        </div>
      </ul> */}
    </div>
  );
}
export default Head;
